module.exports = __webpack_public_path__ + "files/e3323736e2ed014c9ff64eb4a134fb12.png";